/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const fox_buy_banner_close_btn = document.getElementById(
  "fox_buy_banner_close_btn"
);

fox_buy_banner_close_btn.addEventListener("click", function (e) {
  const fox_buy_banner = document.getElementById("fox_buy_banner");

  fox_buy_banner.style.display = "none";
});


// Add background blur to search bar and mega menu while active
const searchBarResults = document.querySelector(".search-bar__results");
const megaMenu = document.querySelector(".nav-bar__linklist");
const headerBar = document.querySelector(".header");  // the background blur will be inserted here

// Create element to blur the background
const backgroundBlur = document.createElement("div");
backgroundBlur.classList.add("background-blur");
headerBar.appendChild(backgroundBlur);

// Create observer to watch for changes in the search bar and mega menu
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (searchBarResults.getAttribute("aria-hidden") === "false" || megaMenu.classList.contains("nav-dropdown--glued")) {
      backgroundBlur.classList.add("active");
    } else {
      backgroundBlur.classList.remove("active");
    }
  });
});

// observe search bar and mega menu
observer.observe(searchBarResults, megaMenu, {
  attributes: true,
});



// check if the device is mobile
if ('ontouchstart' in window) {
  // call animation function on touchstart
  window.addEventListener("touchmove", hideButton);
} else {
  // call animation function on scroll
  window.addEventListener("scroll", hideButton);
}

// Hide buttons while scrolling
let timeout = null;
function hideButton() {
  const chatButton = document.getElementById("dummy-chat-button-iframe");
  const chatButton2 = document.getElementById("ShopifyChat");
  const creditButton = document.getElementById("creditsyard-tab-button");
  let previousPostion = window.pageYOffset;


  // Hide credit button while scrolling
  if (creditButton) {
    creditButton.style.transform = 'translateX(76px)';
  }
  

  // Hide chat button while scrolling
  if (chatButton) {  // Add style while scrolling
    chatButton.style.transform = 'translateX(76px)';
    chatButton.style.transition = 'transform 0.2s ease-in-out';
  }
  if (chatButton2 && !chatButton2.style.minHeight) { // Check that chat button exist and is not minimized
    chatButton2.style.transform = 'translateX(76px)';
    chatButton2.style.transition = 'transform 0.2s ease-in-out';
  }
  if (timeout) {
    clearTimeout(timeout)
  }
  // End the event returning the style the its original state
  timeout = setTimeout(function() {  
    let currentPositon = window.pageYOffset; 
    if (previousPostion === currentPositon) {
      // Show credit button
      if (creditButton) {
        creditButton.style.transform = 'translateX(0)';
      }

      // Show chat button
      if (chatButton) {
        chatButton.style.transform = 'translateX(0)';
      }
      if (chatButton2 && !chatButton2.style.minHeight) {
        chatButton2.style.transform = 'translateX(0)';
      }
    }
    else {
      hideButton(); // Call function again if scroll position is still changing
    }
    }, 1000);
}

const lskdfjlk = '51kNptZqWA0vAxPbc3FF'; 
